import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-screen cf-bg cf-grain grid place-items-center px-4" data-testid="not-found">
      <div className="relative z-10 text-center">
        <p className="font-cinzel text-7xl cf-gold-text font-bold">404</p>
        <h1 className="mt-4 font-playfair text-2xl text-white">Page not found</h1>
        <p className="mt-2 text-muted-foreground">The page you're looking for doesn't exist.</p>
        <Link to="/">
          <Button className="mt-8 cf-gold-btn rounded-full font-semibold h-11 px-7" data-testid="notfound-home-btn">Back to Home</Button>
        </Link>
      </div>
    </div>
  );
}
